import { ErrorModal } from "@dexteel/mesf-core";
import {
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
} from "@material-ui/core";
import { get } from "lodash-es";
import { useEffect, useRef, useState } from "react";
import { useDataEntryContext } from "../context/reducer.provider";
import { getPhaseEventTypes } from "../repositories/eaf.repositories";
import { useStyles } from "../styles/useDEStyles";

interface PhaseEvent {
	PhaseEventTypeId: number;
	EventDescription: string;
}

export const PhaseEventSelector = ({
	value,
	onChange,
	disabled,
	error,
	helperText,
}: {
	value: number | null;
	onChange: (value: number) => void;
	disabled: boolean;
	error?: string;
	helperText?: string;
}) => {
	const isFirstRender = useRef(true);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [fetchError, setFetchError] = useState<string>("");
	const [options, setOptions] = useState<PhaseEvent[]>([]);
	const [phaseEvent, setPhaseEvent] = useState<number>();
	const classes = useStyles();

	const loadData = async () => {
		setIsLoading(true);
		const resp = await getPhaseEventTypes();
		if (resp.ok) {
			const phaseEvents = get(resp, "data.tables[0].rows", []);
			setOptions(phaseEvents);
		} else {
			setFetchError(resp.message!);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			loadData().then(() => {});
			return;
		}
	}, []);

	return (
		<>
			<FormControl variant="outlined" fullWidth>
				<InputLabel id="phaseEventSelector" className={classes.inputLabel}>
					Phase Event
				</InputLabel>
				<Select
					fullWidth
					disabled={isLoading || disabled}
					labelId="phaseEventSelector"
					id="phaseEventSelector"
					value={value || ""}
					error={!!error}
					onChange={(event) => {
						const selectedValue = event.target.value as number;
						onChange(selectedValue);
						setPhaseEvent(selectedValue);
					}}
					label="Phase Event"
				>
					{options.map((option) => (
						<MenuItem
							key={`phase-event-${option.PhaseEventTypeId}`}
							value={option.PhaseEventTypeId}
						>
							{option.EventDescription}
						</MenuItem>
					))}
				</Select>
				{error && <FormHelperText error>{error}</FormHelperText>}
			</FormControl>
			<ErrorModal error={fetchError} onHide={() => setFetchError("")} />
		</>
	);
};
